import { useEffect, useState } from "react";
import { fetchArticles, fetchCategories } from "../lib/api";
import ArticleCard from "../components/ArticleCard";
import Breadcrumbs from "../components/Breadcrumbs";

export default function Guides() {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState("All");

  useEffect(() => {
    fetchArticles({ type: "guide" }).then(setItems).catch(() => {});
    fetchCategories().then(setCategories).catch(() => {});
  }, []);

  const filtered = active === "All" ? items : items.filter((i) => i.category === active);

  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14" data-testid="guides-page">
      <Breadcrumbs items={[{ label: "Guides" }]} />
      <header className="mb-12 max-w-3xl">
        <p className="eyebrow mb-3">Guides</p>
        <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl text-neutral-900 tracking-tight leading-[1.05] mb-5">
          Practical guides for choosing software.
        </h1>
        <p className="text-lg text-neutral-600 leading-relaxed">
          Plain-English explanations and buyer frameworks for the software
          decisions businesses actually face.
        </p>
      </header>

      <div className="flex flex-wrap items-center gap-2 mb-10">
        {["All", ...categories.map((c) => c.name)].map((name) => (
          <button
            key={name}
            type="button"
            onClick={() => setActive(name)}
            data-testid={`guides-filter-${name.toLowerCase().replace(/[^\w]+/g, "-")}`}
            className={`px-4 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
              active === name
                ? "bg-indigo-800 border-indigo-800 text-surface"
                : "bg-surface border-neutral-300 text-neutral-700 hover:border-indigo-800 hover:text-indigo-800"
            }`}
          >
            {name}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
        {filtered.map((a, i) => (
          <ArticleCard key={a.id} article={a} basePath="/guides" index={i} />
        ))}
      </div>
    </div>
  );
}
